import { render, staticRenderFns } from "./sentAtSearch.vue?vue&type=template&id=54748908&"
import script from "./sentAtSearch.vue?vue&type=script&lang=js&"
export * from "./sentAtSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports